export const sliderStyles = (hue: number, saturation: number, lightness: number) => ({
  color: `hsl(${hue}, ${saturation}%, ${lightness}%)`,

  '& .MuiSlider-thumb': {
    width: 18,
    height: 18,
    backgroundColor: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      boxShadow: '0 0 6px rgba(0, 0, 0, 0.4)',
      width: 18,
      height: 18,
    },
    '&.Mui-active': {
      boxShadow: '0 0 8px rgba(0, 0, 0, 0.5)',
      width: 18,
      height: 18,
    },
    '&.Mui-focusVisible': {
      boxShadow: '0 0 6px rgba(0, 0, 0, 0.4)',
      width: 18,
      height: 18,
    },
  },
  '& .MuiSlider-track': {
    background: `linear-gradient(
      to right,
      hsl(${hue}, 0%, ${lightness}%) 0%,
      hsl(${hue}, 25%, ${lightness}%) 25%,
      hsl(${hue}, 50%, ${lightness}%) 50%,
      hsl(${hue}, 75%, ${lightness}%) 75%,
      hsl(${hue}, 100%, ${lightness}%) 100%
    )`,
    transition: 'background 0.2s ease',
    border: 'none',
    height: '8px',
  },
  '& .MuiSlider-rail': {
    background: `linear-gradient(
      to right,
      hsl(${hue}, 0%, ${lightness}%) 0%,
      hsl(${hue}, 25%, ${lightness}%) 25%,
      hsl(${hue}, 50%, ${lightness}%) 50%,
      hsl(${hue}, 75%, ${lightness}%) 75%,
      hsl(${hue}, 100%, ${lightness}%) 100%
    )`,
    transition: 'background 0.2s ease',
    height: '8px',
  },
});
